import styled from 'styled-components';
import { Col } from 'components/Core/Grid';

const DesktopContainer = styled.div`
  .in-page-features-v3--navigation {
    display: flex;
    align-items: center;
    height: 100%;
  }

  .in-page-features-v3--item-column {
    padding: 0 !important;
  }

  .in-page-features-v3--content {
    height: 540px;
  }

  .in-page-features-v3--inner-container.title-included {
    padding-top: 60px;
  }

  .in-page-features-v3--inner-container.toggle-component {
    padding-top: ${({ multiLineTitle }) => (multiLineTitle ? '71px' : '40px')};
  }
`;

const FeaturedContent = styled(Col)`
  text-align: center;
  height: 100%;

  .in-page-features-v3--featured-content-container {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;

    &.hide-feature {
      position: absolute;
      left: -999em;
    }

    &.show-feature {
      display: flex;
      justify-content: center;
    }
  }

  .in-page-features-v3--featured-content {
    height: 100%;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    .in-page-features-v3--featured-content-heading {
      font-size: var(--font-size-p-md);
      letter-spacing: 0;

      @media (max-width: 767px) {
        font-size: var(--font-size-mobile-p-md);
      }
    }

    .in-page-features-v3--featured-content-description {
      padding: 0 20px;

      @media (max-width: 991px) {
        padding: 0;
      }
    }
  }

  .gatsby-image-wrapper {
    max-height: 500px;
    max-width: 100%;

    img {
      bottom: 0;
      right: 0;
      margin: auto;
    }
  }
`;

const FeaturedContentInnerContainer = styled.div`
  width: 100%;
  flex: 1;
  margin: 0 auto;
`;

const StyledTitle = styled.h2`
  padding: 75px 0 20px 0;
  margin: 0;
  text-align: center;

  @media (max-width: 575px) {
    padding: 75px 28px 0 28px;
  }
`;

export { DesktopContainer, FeaturedContent, FeaturedContentInnerContainer, StyledTitle };
